var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.enableTool
    ? _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.enableAddFeature
            ? _c("ControlAddFeature", {
                attrs: {
                  "data-panel": _vm.pageID,
                  idControl: _vm.pageID,
                  actionName: _vm.actionName,
                  moduleCode: _vm.moduleCode,
                  showButtonOnActionMap: _vm.showButtonOnActionMap,
                  eventInitialize: _vm.eventInitialize,
                  eventFinished: _vm.eventFinished,
                  eventShowModal: _vm.eventShowModal,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }